import { useApiGet } from '../../../services/tanstackApiService';

// ============================================================================
// Types
// ============================================================================

export interface PharmacyPaymentTransaction {
  payment_detail_id: number;
  payment_id: number;
  invoice_id: number;
  date: string; // ISO 8601 timestamp: "2025-12-27T10:54:00.507201Z"
  paid_amount: number | string; // Can be number or string from API
  payment_mode_id: number;
  payment_mode_name: string;
  reference_number: string | null;
  is_refunded: boolean;
}

export interface PharmacyPaymentsResponse {
  success: boolean;
  transactions: PharmacyPaymentTransaction[];
}

// ============================================================================
// API Hooks
// ============================================================================

export interface UsePharmacyPaymentsQueryParams {
  invoiceId: number;
  enabled?: boolean;
}

/**
 * React Query hook to fetch payments for a specific pharmacy invoice.
 * @param invoiceId - The pharmacy invoice ID
 * @param enabled - Whether to enable the query
 * @returns Query result with pharmacy payment transactions
 */
export function usePharmacyPaymentsQuery({
  invoiceId,
  enabled = true
}: UsePharmacyPaymentsQueryParams) {
  return useApiGet<PharmacyPaymentsResponse>(
    ['pharmacyInvoice', 'payments', invoiceId],
    {
      path: `payments/invoice/${invoiceId}/`,
    },
    {
      enabled: enabled && invoiceId > 0,
    }
  );
}
